import { FETCH_AGENTS_FAIL } from 'constants/action_types'

export default function failAction(error) {
  return { type: FETCH_AGENTS_FAIL, data: { err: error } }
}
